<script setup lang="ts">
import { Globe } from 'lucide-vue-next'

const frontendUrl = import.meta.env.VITE_FRONTEND_URL || '/'
</script>

<template>
  <VaButton
    preset="secondary"
    color="textPrimary"
    :href="frontendUrl"
    target="_blank"
    title="Перейти на основной сайт"
    class="view-website-button"
  >
    <Globe :size="20" />

    <span class="hidden sm:inline-block ml-2 text-sm font-semibold">На сайт</span>
  </VaButton>
</template>

<style scoped>
.view-website-button {
  height: 2.5rem;
  padding: 0 0.75rem;
}
</style>
